<template>
  <v-container fluid>
    <v-card class="pa-6 mx-auto" elevation="4" max-width="600" rounded="xl">
      <h2 class="text-h5 mb-4">Recargar líneas del planificador</h2>

      <v-select
        v-model="delegacio"
        :items="delegacions"
        label="Selecciona la delegación"
        item-title="title"
        item-value="value"
        :disabled="carregant"
        @update:modelValue="executarConsultes"
      />

      <v-progress-circular
        v-if="carregant"
        indeterminate
        color="primary"
        class="mt-4"
      />

      <v-alert
        v-for="(res, index) in resultats"
        :key="index"
        :type="res.ok ? 'success' : 'error'"
        class="mt-3"
      >
        {{ res.missatge }}
      </v-alert>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

const delegacio = ref('')
const carregant = ref(false)
const resultats = ref([])

const delegacions = [
    { title: 'Barcelona', value: '453' },
    { title: 'Madrid', value: '502' },
    { title: 'Girona', value: '7042' },
    { title: 'Tarragona', value: '2016' },
    { title: 'Toledo', value: '7153' },
    { title: 'Guadalajara', value: '9784' },
    { title: 'Traycco Caprabo', value: '8774' },
    { title: 'Traycco Alcampo', value: '9126' },
]

const clients = [
  'GEDEM', 'ALCAMPO', 'CAPRABO', 'JYSK',
  'Distribuidora Internacional Alimentac', 'PRIMAPRIX',
  'CARREFOUR', 'SUPECO', 'OBRAMAT', 'DIA', 'MEYDIS'
]

const executarConsultes = async (novaDelegacio) => {
  if (!novaDelegacio) return

  delegacio.value = novaDelegacio
  resultats.value = []
  carregant.value = true

  // 1. Consulta general (sense client)
  await consultar(delegacio.value)

  // 2. Consulta per cada client
  for (const client of clients) {
    await consultar(delegacio.value, client)
  }

  carregant.value = false
}

const consultar = async (delegacioId, client = null) => {
  const dades = new URLSearchParams()
  dades.append('delegacio', delegacioId)
  if (client) dades.append('client', client)

  try {
    const resposta = await axios.post('https://traycco.com/Planificador/a1_carregar_dades_v2.php', dades, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true
    })

    const data = resposta.data
console.log (data)
    resultats.value.push({
      ok: true,
      missatge: client
        ? `✅ ${data.linies_processades} líneas cargadas por ${data.client} (${data.data_ini} - ${data.data_fi})`
        : `✅ ${data.linies_processades} líneas cargadas sin cliente`
    })
  } catch (err) {
    console.error(err)
    resultats.value.push({
      ok: false,
      missatge: client
        ? `❌ Error per al client ${client}`
        : `❌ Error en la consulta general`
    })
  }
}
</script>
